export const MOVIE_SEARCH_REQUEST = 'MOVIE_SEARCH_REQUEST'
export const MOVIE_SEARCH_RESPONSE = 'MOVIE_SEARCH_RESPONSE'
export const SEARCH_MOVIES_QUERY_RESPONSE = 'SEARCH_MOVIES_QUERY_RESPONSE'
export const SEARCH_MOVIES_QUERY_REQUEST = 'SEARCH_MOVIES_QUERY_REQUEST'
